import React from 'react';
import {t} from '@lingui/core/macro';

import {PaymentStatusBadge, IPayment} from 'entities/payment';
import {getFormattedDate} from 'shared/lib/datetime';
import {isTranslate} from 'shared/lib/lang';

interface IPaymentRowProps {
    item: IPayment,
    tzString?: string | null,
}

const PaymentRow: React.FC<IPaymentRowProps> = ({item, tzString}) => {

    return (
        <tr>
            <td>{item.number}</td>
            <td>{getFormattedDate(item.created_at, {tzString})}</td>
            <td>{ isTranslate() && '$ '}{item.sum} { !isTranslate() && ' ₽'}</td>
            <td>{item.tariff.name}{item.tariff.is_archive && ` (${t`архивный`})`}</td>
            <td>{item.auto ? t`Автоплатёж` : t`Ручная оплата`} </td>
            <td><PaymentStatusBadge status={item.status}/></td>
            <td>{getFormattedDate(item.payed_at, {tzString})}</td>
        </tr>
    );
};

export default PaymentRow;